// @ts-strict-ignore
import { clsx } from 'clsx';
import { Button, Typography } from 'onboarding-components';
import * as React from 'react';
import { SvgIconReact } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import styles from '../index.module.styl';
import { track, TrackingEvent, TrackingProperty } from '../tracking';
import { SetupGuideContext, Step } from '../types';
const StepIndicatorV2 = _ref => {
  let {
    isCompleted,
    moniker,
    children,
    step: targetStep
  } = _ref;
  const {
    step,
    setStep
  } = React.useContext(SetupGuideContext);
  return <div className={clsx({
    [styles.completed]: isCompleted
  }, styles.indicator, {
    [styles.current]: step === targetStep
  })} onClick={() => {
    setStep(targetStep);
    track(TrackingEvent.StepClick, {
      [TrackingProperty.Source]: "SideNav",
      [TrackingProperty.StepName]: targetStep
    });
  }} data-sentry-component="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
      {isCompleted ? <div className={clsx(styles.moniker, styles.completed, {
      [styles.current]: step === targetStep
    })}>
          <SvgIconReact icon='checkmark' />
        </div> : <div className={clsx(styles.moniker, {
      [styles.current]: step === targetStep
    })}>
          <Typography variant='eyebrowSm' weight='bold' style={{
        letterSpacing: 0,
        lineHeight: "100%"
      }}>
            {moniker}
          </Typography>
        </div>}
      <Typography variant='bodySm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="side-nav.tsx">
        {children}
      </Typography>
    </div>;
};
export const SideNavPhase2 = _ref2 => {
  let {
    onClose
  } = _ref2;
  const {
    completed
  } = React.useContext(SetupGuideContext);
  const {
    t
  } = useTranslation();
  return <div className={styles.nav} data-sentry-component="SideNavPhase2" data-sentry-source-file="side-nav.tsx">
      <div>
        <Typography variant='headingMd' style={{
        margin: 0
      }} data-sentry-element="Typography" data-sentry-source-file="side-nav.tsx">
          {t("onboarding-legacy.sidenav.setup-guide")}
        </Typography>
        <Typography variant='bodySm' className={styles.subtitle} data-sentry-element="Typography" data-sentry-source-file="side-nav.tsx">
          {t("onboarding-legacy.sidenav.up-and-running")}
        </Typography>
        <div className={styles.indicatorGroup}>
          {/* Replace with components */}
          <StepIndicatorV2 isCompleted={completed[Step.Welcome]} moniker={1} step={Step.Welcome} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding-legacy.sidenav.start-here")}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Events]} moniker={2} step={Step.Events} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding-legacy.sidenav.personalize-setup")}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Implement]} moniker={3} step={Step.Implement} data-sentry-element="StepIndicatorV2" data-sentry-source-file="side-nav.tsx">
            {t("onboarding-legacy.sidenav.connect-data")}
          </StepIndicatorV2>
        </div>
      </div>
      <Button onClick={onClose} variant='inline' color='dark' className={styles.footerButton} data-sentry-element="Button" data-sentry-source-file="side-nav.tsx">
        {completed[Step.Welcome] && completed[Step.Events] && completed[Step.Implement] ? t("common.close") : t("onboarding.sidenav.skip-for-now")}
      </Button>
    </div>;
};